<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">

      <!-- Col 1 -->
      <div class="vx-col w-full md:w-1/2">
        <vs-input
          class="w-full"
          :value="this.$store.state.userManagement.userProfile.twitter"
          icon-pack="feather"
          icon="icon-twitter"
          label="Twitter"
          @input="setTwitter"
          icon-no-border
          name="twitter" />
          <span class="text-danger text-sm"  v-show="errors.has('twitter')">{{ errors.first('twitter') }}</span>

        <vs-input
          class="w-full mt-4"
          :value="this.$store.state.userManagement.userProfile.facebook"
          icon-pack="feather"
          icon="icon-facebook"
          label="Facebook"
          @input="setFacebook"
          icon-no-border
          name="facebook" />
          <span class="text-danger text-sm"  v-show="errors.has('facebook')">{{ errors.first('facebook') }}</span>

        <vs-input
          class="w-full mt-4"
          :value="this.$store.state.userManagement.userProfile.instagram"
          icon-pack="feather"
          icon="icon-instagram"
          label="Instagram"
          @input="setInstagram"
          icon-no-border
          name="instagram" />
          <span class="text-danger text-sm"  v-show="errors.has('instagram')">{{ errors.first('instagram') }}</span>

      </div>

      <!-- Col 2 -->
      <div class="vx-col w-full md:w-1/2">
        <vs-input
          class="w-full mt-4 md:mt-0"
          :value="this.$store.state.userManagement.userProfile.skype"
          icon-pack="feather"
          icon="icon-phone"
          label="Skype"
          @input="setSkype"
          icon-no-border
          name="github" />
          <span class="text-danger text-sm"  v-show="errors.has('github')">{{ errors.first('github') }}</span>

        <vs-input
          class="w-full mt-4"
          :value="this.$store.state.userManagement.userProfile.slack"
          icon-pack="feather"
          icon="icon-slack"
          label="Slack"
          @input="setSlack"
          icon-no-border
          name="codepen" />
          <span class="text-danger text-sm"  v-show="errors.has('codepen')">{{ errors.first('codepen') }}</span>

        <vs-input
          class="w-full mt-4"
          :value="this.$store.state.userManagement.userProfile.blog"
          icon-pack="feather"
          icon="icon-globe"
          label="Blog"
          @input="setBlog"
          icon-no-border
          name="slack" />
          <span class="text-danger text-sm"  v-show="errors.has('slack')">{{ errors.first('slack') }}</span>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Salvar Alterações</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data_local: null
    }
  },
  computed: {
    validateForm () {

      const specialRegex = new RegExp('^[0-9a-zA-Z ãâáàéêè\b]+$')


      if (!this.$store.state.userManagement.userProfile.name) {
        this.$vs.notify({
          title: 'Warning',
          text: 'The name field in Account Tab is required',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      
      if (this.$store.state.userManagement.userProfile.languages && this.$store.state.userManagement.userProfile.languages.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'The languages field in Information Tab is required',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      } 

      // if(/\d/.test(this.$store.state.userManagement.userProfile.website)) {
      //   this.errors.add({field: 'website', msg: 'The website field may only contain alphabetic characters as well as spaces'})

      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      // if(/[`!#$%^&*()_+\-=\[\]{};'"\\|,<>\?~]/.test(this.$store.state.userManagement.userProfile.website)) {
      //   this.errors.add({field: 'website', msg: 'The website field may contain alpha-numeric characters as well as dashes and underscores'})

      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })
        
      //   return false
      // }

      if (this.$store.state.userManagement.userProfile.mobile && this.$store.state.userManagement.userProfile.mobile.length < 10 && this.$store.state.userManagement.userProfile.mobile.length > 0) {
        this.errors.add({field: 'mobile', msg: 'The Mobile field is incomplete'})

        this.$vs.notify({
          title: 'Warning',
          text: 'Check all fields',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      } else {
        return true
      }

      // if(!specialRegex.test(this.$store.state.userManagement.userProfile.post_code)) {
      //     this.$vs.notify({
      //       title: 'Warning',
      //       text: 'Check all fields',
      //       iconPack: 'feather',
      //       icon: 'icon-alert-circle',
      //       color: 'warning'
      //     })

      //     return false
      //   }

      // if(/[a-zA-Z]/g.test(this.$store.state.userManagement.userProfile.post_code)) {

      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      // if(!specialRegex.test(this.$store.state.userManagement.userProfile.city)) {
      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      // if(/\d/.test(this.$store.state.userManagement.userProfile.city)) {

      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      // if(!specialRegex.test(this.$store.state.userManagement.userProfile.state)) {
      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      // if(/\d/.test(this.$store.state.userManagement.userProfile.state)) {

      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      // if(!specialRegex.test(this.$store.state.userManagement.userProfile.country)) {
      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      // if(/\d/.test(this.$store.state.userManagement.userProfile.country)) {

      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Check all fields',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }

      if (/\s/.test(this.$store.state.userManagement.userProfile.name) && this.$store.state.userManagement.userProfile.name.trim() === '') {
        this.$vs.notify({
          title: 'Warning',
          text: 'The name field in Account Tab must be a valid name',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }


      return !this.errors.any()
    }
  },
  methods: {
    setTwitter (e) {
      this.$store.commit('userManagement/setTwitter', e)
    },
    setFacebook (e) {
      this.$store.commit('userManagement/setFacebook', e)
    },
    setInstagram (e) {
      this.$store.commit('userManagement/setInstagram', e)
    },
    setSkype (e) {
      this.$store.commit('userManagement/setSkype', e)
    },
    setSlack (e) {
      this.$store.commit('userManagement/setSlack', e)
    },
    setBlog (e) {
      this.$store.commit('userManagement/setBlog', e)
    },
    async fetch_user_data (userSession, appToken, apiUrl) {
      this.$vs.loading({type: 'default'})
      return await this.$store.dispatch('userManagement/fetchUserProfile', {userSession, appToken, apiUrl})
        .then((res) => {
          this.$vs.loading.close()
          this.$store.dispatch('userManagement/setUserProfile', res)
          this.user_data = res
        })
        .catch(err => {
          this.$vs.loading.close()
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err) 
        })
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading({type: 'default'})

      this.$store.dispatch('userManagement/saveChanges', {userProfile: this.$store.state.userManagement.userProfile, apiUrl: this.$store.state.auth.api_url})
      .then(async (result) => {
        this.$vs.loading.close()

        await this.fetch_user_data(this.$store.state.auth.token, this.$store.state.auth.app_token, this.$store.state.auth.api_url)

        this.$store.commit('auth/SET_USER_NAME', this.$store.state.userManagement.userProfile.name)
        this.$store.commit('auth/SET_USER_PHOTO', this.$store.state.userManagement.userProfile.photo)
        this.$store.commit('auth/SET_USER_USERNAME', this.$store.state.userManagement.userProfile.username)
        this.$store.commit('auth/SET_USER_MOBILE', this.$store.state.userManagement.userProfile.mobile)
        localStorage.setItem('user', JSON.stringify(this.$store.state.auth.user))

        this.$vs.notify({
            title: 'Operação Realizada!',
            text: `Dados alterados com sucesso!`,
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })

      })
      .catch((err) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Erro',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
